import { MobileMenuVisibility } from '~/store/ui/mobile-menu/types'

export interface IUiMobileMenuState {
  mobileMenuVisibility: MobileMenuVisibility
}

export default (): IUiMobileMenuState => ({
  mobileMenuVisibility: 'hidden',
})
